export default __webpack_public_path__ + "static/media/image.d2f55336.svg";